import { Text, Input } from "@chakra-ui/react";
import { AccountPermission } from "@syla/shared/types/models/AccountAccessBase";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { hasAccountPermission } from "../../../helper/permissions";
import { useReportError } from "../../../helpers/useReportError";
import { useMutationUpdateAccount } from "../../../store/useMutationUpdateAccount";
import { Account } from "../../../types/Account";
import {
  EditableFieldProps,
  EditableField,
} from "../../molecules/EditableField";

export function AccountNameEditable({
  account,
  ...props
}: { account: Account } & Partial<EditableFieldProps>) {
  const { mutateAsync: updateAccount } = useMutationUpdateAccount(account._id);
  const [updateInProgress, setUpdateInProgress] = useState(false);
  const reportError = useReportError();

  const canChangeAccountDetails = hasAccountPermission(
    account,
    AccountPermission.ChangeAccountDetails,
  );

  const { watch, register, formState, resetField } = useFormContext<{
    fullName: string;
  }>();
  return (
    <EditableField
      displayElement={<Text>{watch("fullName")}</Text>}
      editElement={<Input autoFocus {...register("fullName")} />}
      isDirty={formState.dirtyFields.fullName}
      isLoading={updateInProgress}
      onSave={async () => {
        try {
          setUpdateInProgress(true);
          await updateAccount({
            fullName: watch("fullName"),
          });
        } finally {
          setUpdateInProgress(false);
        }
      }}
      validate={() =>
        !watch("fullName").trim() ? "Account name can't be empty" : undefined
      }
      onCancel={() => resetField("fullName")}
      onError={reportError}
      canEdit={canChangeAccountDetails}
      {...props}
    />
  );
}
